import {
  Box,
  ClickAwayListener,
  IconButton,
  Popper,
  Typography,
  useTheme,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { tokens } from '../../global/theme/tokens';

/**
 * Small info icon that opens a popper with the `info` text on click.
 * Renders nothing when no `info` text is provided, so it is safe to use
 * unconditionally inside any field type or wrapper.
 */
export const FieldInfo = ({ info }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!info) return null;

  const handleToggle = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        className="no-nav"
        size="small"
        type="button"
        tabIndex={-1}
        onClick={handleToggle}
        sx={{ color: colors.info }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        sx={{ zIndex: 9999, paddingTop: '4px' }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Box
            sx={{ bgcolor: colors.card, maxWidth: '280px' }}
            className="backdrop-blur-lg rounded-lg p-3 shadow-md"
          >
            <Typography variant="body2">{info}</Typography>
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default FieldInfo;
